// A filter over a handful of fields is noise, so the settings search appears
// only from this many settings up. Sections range from three fields (a plain
// text block) to over thirty (a booking calendar).
export const MIN_SETTINGS_FOR_FILTER = 10

// Diacritics are folded, so "zdjecie" finds "Zdjęcie". 'ł' has no decomposed
// form and is mapped by hand.
export function normalizeSettingText (text: string): string {
  return (text || '')
    .toLowerCase()
    .replace(/ł/g, 'l')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .trim()
}

export function matchesSettingFilter (label: string, query: string): boolean {
  const normalizedQuery = normalizeSettingText(query)

  return normalizedQuery.length === 0 || normalizeSettingText(label).indexOf(normalizedQuery) >= 0
}
